/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.querySelectorAll('.chair_bed_video').forEach((container) => {
  const video = container.querySelector('.slide-video');
  const playPauseBtn = container.querySelector('.play-pause-btn');
  const playIcon = playPauseBtn.querySelector('.play-icon');
  const pauseIcon = playPauseBtn.querySelector('.pause-icon');

  playPauseBtn.addEventListener('click', () => {
    if (video.paused || video.ended) {
      video.play().then(() => {
        playIcon.style.display = "none"; // Hide play icon
        pauseIcon.style.display = "inline"; // Show pause icon
        playPauseBtn.classList.add('playing'); // Add 'playing' class
        playPauseBtn.classList.remove('paused'); // Remove 'paused' class
      }).catch((error) => {
        console.error("Error attempting to play the video:", error);
      });
    } else {
      video.pause();
      playIcon.style.display = "inline"; // Show play icon
      pauseIcon.style.display = "none"; // Hide pause icon
      playPauseBtn.classList.add('paused'); // Add 'paused' class
      playPauseBtn.classList.remove('playing'); // Remove 'playing' class
    }
  });

  // Reset button state when the video ends
  video.addEventListener('ended', () => {
    playIcon.style.display = "inline"; // Show play icon
    pauseIcon.style.display = "none"; // Hide pause icon
    playPauseBtn.classList.add('paused'); // Add 'paused' class
    playPauseBtn.classList.remove('playing'); // Remove 'playing' class
  });
});




document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".testimonialSwiper", {
      slidesPerView: 3,
      // centeredSlides: true,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
       breakpoints: {
        300: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      }
    });
});


document.addEventListener("DOMContentLoaded", function () {
  function initializeVideoControls() {
    document.querySelectorAll(".video-item").forEach((videoItem) => {
      const video = videoItem.querySelector(".slide-video");
      const toggleButton = videoItem.querySelector(".play_pause_toggle");

      if (!video || !toggleButton) return; // Ensure elements exist

      const playIcon = toggleButton.querySelector(".play");
      const pauseIcon = toggleButton.querySelector(".pause");

      toggleButton.addEventListener("click", function () {
        if (video.paused) {
          // Pause all other videos before playing the clicked one
          document.querySelectorAll(".slide-video").forEach((vid) => {
            if (vid !== video) {
              vid.pause();
              const parent = vid.closest(".video-item");
              if (parent) {
                parent.querySelector(".play").style.display = "flex";
                parent.querySelector(".pause").style.display = "none";
              }
            }
          });

          video.play();
          playIcon.style.display = "none";
          pauseIcon.style.display = "flex";
        } else {
          video.pause();
          playIcon.style.display = "flex";
          pauseIcon.style.display = "none";
        }
      });

      // Reset button state when video ends
      video.addEventListener("ended", function () {
        playIcon.style.display = "flex";
        pauseIcon.style.display = "none";
      });
    });
  }

  // Ensure the script runs when navigating between pages (for Shopify AJAX navigation)
  document.addEventListener("shopify:section:load", initializeVideoControls);
  initializeVideoControls(); // Run on initial page load
});




